import { useCallback, useEffect, useState } from 'react';
import api from '../lib/api';

export function useSystemHealth(enabled = true) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [receivedAt, setReceivedAt] = useState(0);
  const [now, setNow] = useState(Date.now());
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey(key => key + 1), []);
  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;
    let running = false;
    const controller = new AbortController();
    const poll = async () => {
      if (running || document.hidden) return;
      running = true;
      try {
        const result = await api.get('/system-health', { signal: controller.signal, timeout: 12000 });
        if (!stopped) {
          setData(result.data); setError(false); setReceivedAt(Date.now());
        }
      } catch (err) {
        if (!stopped) setError(true);
      } finally {
        running = false;
        if (!stopped) setLoading(false);
      }
    };
    poll();
    const timer = setInterval(poll, 15000);
    const clock = setInterval(() => setNow(Date.now()), 5000);
    document.addEventListener('visibilitychange', poll);
    return () => {
      stopped = true; controller.abort(); clearInterval(timer); clearInterval(clock);
      document.removeEventListener('visibilitychange', poll);
    };
  }, [enabled, refreshKey]);
  const stale = error || !data?.available || data?.stale ||
    (data.age_seconds || 0) + Math.max(0, now - receivedAt) / 1000 > 180;
  return { data, loading, error, stale, refresh, overall: stale ? 'unknown' : data.overall };
}
